import React, { createElement, Fragment } from "react";
import { Helmet } from "react-helmet";

import { HowItWorks } from "ducks/HowItWorks/index";

export default function HowItWorksPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>{"How It Works - Savant Power"}</title>
      </Helmet>
      {createElement(HowItWorks, props)}
    </Fragment>
  );
}
